require('../../modules/es7.symbol.async-iterator');
module.exports = require('../../modules/_wks-ext').f('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/symbol/async-iterator.js
// module id = 543
// module chunks = 8